module.exports = __webpack_public_path__ + "img/car.5e864b18.png";